/**
 * Ryan O'Dowd
 * 2025-06-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode, fonts}) => {
  const containerAndLabelAttrs = { // @TODO: abstract with FormControl
    backgroundColor: isDarkMode ? colors.completeBg : colors.white,
    borderWidth: 3,
    borderColor: isDarkMode ? colors.gray : colors.lightGray,
    borderTopLeftRadius: globalScale * 12,
    borderTopRightRadius: globalScale * 12,
    borderBottomRightRadius: globalScale * 12,
    borderBottomLeftRadius: globalScale * 12,
  };

  return {
    container: {
      position: 'absolute',
      left: globalScale * 10,
      top: globalScale * -10, // @TODO: should be transform y up 50% of selfheight
      ...containerAndLabelAttrs,
    },
    containerAlert: {
      borderColor: colors.alert,
    },
    labelText: {
      fontSize: globalScale * 11,
      color: isDarkMode ? colors.primaryLight : colors.primaryDark,
      fontFamily: fonts.secondaryBold,
      paddingHorizontal: globalScale * 4,
    },
  };
};

export default getStyles;
